import { render } from "./HomeItsIndustriesComp.vue?vue&type=template&id=d677b610&scoped=true"
import script from "./HomeItsIndustriesComp.vue?vue&type=script&lang=js"
export * from "./HomeItsIndustriesComp.vue?vue&type=script&lang=js"

import "./HomeItsIndustriesComp.vue?vue&type=style&index=0&id=d677b610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d677b610"]])

export default __exports__